import { useUrlConfigModelStore } from '@/models/url-config/urlConfig';
import { Avatar } from 'aui';
import clsx from 'clsx';
import styles from './ExportFormatSelectGroup.module.css';

export interface ExportFormatSelectGroupProps {
  options: { label: string; value: string; icon: string; isHide?: boolean }[];
  value: string;
  onChange: (type: string) => void;
  className?: string;
}

export function ExportFormatSelectGroup(props: ExportFormatSelectGroupProps) {
  const { options, value, onChange, className } = props;

  const icons = useUrlConfigModelStore((x) => x.icon);

  return (
    <div className={clsx('flex gap-2', className)}>
      {options
        .filter((res) => !res.isHide)
        .map((item) => {
          const isActive = value === item.value;

          return (
            <div
              key={item.value}
              className={clsx(
                'flex flex-col items-center justify-center gap-1 rounded-lg',
                styles.selectItem,
                isActive ? styles.active : undefined,
              )}
              onClick={() => {
                if (isActive) {
                  return;
                }
                onChange(item.value);
              }}
            >
              <Avatar src={icons?.[item.icon]} shape="square" size="small" />
              <div>{item.label}</div>
            </div>
          );
        })}
    </div>
  );
}
